import ProductServices from '@/services/ProductServices'
import FileServices from "@/services/FileServices";
import CodeCreate from '../../code/CodeCreate'
import CodeList from '@/code/CodeList'
import {AUTH_GROUP} from '@/constants/constants'

const types = {
  GET_PRODUCT_LIST: '@product/GET_PRODUCT_LIST',
  GET_PRODUCT_SEARCH_PARAM: '@product/GET_PRODUCT_SEARCH_PARAM',
  GET_PRODUCT_RANK_SEARCH_PARAM: '@product/GET_PRODUCT_RANK_SEARCH_PARAM',
  GET_PRODUCT_CUSTOMER_SEARCH_PARAM: '@product/GET_PRODUCT_CUSTOMER_SEARCH_PARAM',
  GET_SELECT_PRODUCT_INFO: '@product/GET_SELECT_PRODUCT_INFO',
  CLEAR_SELECT_PRODUCT_INFO: '@product/CLEAR_SELECT_PRODUCT_INFO',
  SET_SELECT_PRODUCT: '@product/SELECT_PRODUCT',
  UPDATE_PRODUCT_INFO: '@product/UPDATE_PRODUCT_INFO',
  CREATE_PRODUCT_STATUS: '@product/CREATE_PRODUCT_STATUS',
  CREATE_PRODUCT_FILE_STATUS: '@product/CREATE_PRODUCT_FILE_STATUS',
  CREATE_SELECT_PRODUCT_INFO_STATUS: '@product/CREATE_SELECT_PRODUCT_INFO_STATUS',
  CHUNK_FILE_UPLOAD: '@product/CHUNK_FILE_UPLOAD',
  DELETE_FILE: '@product/DELETE_FILE',
  ADD_DELETE_FILE: '@product/ADD_DELETE_FILE',
  CLEAR_DELETE_FILE_LIST: '@product/CLEAR_DELETE_FILE_LIST',
  GET_USED_AMOUNT_PRODUCT_LIST: '@product/GET_USED_AMOUNT_PRODUCT_LIST',
  GET_USED_AMOUNT_PRODUCT_PAGING: '@product/GET_USED_AMOUNT_PRODUCT_PAGING',
  GET_PRODUCT_RANK_LIST: '@product/GET_PRODUCT_RANK_LIST',
  GET_PRODUCT_RANK_PAGING: '@product/GET_PRODUCT_RANK_PAGING'
}

export {
  types as productTypes
}

export default {
  namespaced: true,
  state: {
    codeProductList: CodeList.READY,
    productSearchParam: {
      loaded: false
      , pageNo: 1
      , searchText: ''
      , category: 'all'
      , pageSize: 20
      , startMonth: ''
      , endMonth: ''
    },
    productRankSearchParam: {
      loaded: false
      , pageNo: 1
      , search: ''
      , category: 'all'
      , pageSize: 20
      , startMonth: ''
      , endMonth: ''
    },
    productCustomerSearchParam: {
      loaded: false
      , pageNo: 1
      , search: ''
      , category: 'all'
      , pageSize: 20
      , startMonth: ''
      , endMonth: ''
    },
    productList: [],
    selectProduct: {},
    selectProductInfo: {},
    codeProductUpdate: CodeCreate.READY,
    codeProductFileUpdate: CodeCreate.READY,
    codeSelectProductInfo: CodeCreate.READY,
    productException: {},
    fileInfo: {},
    pagingDTO : {
      pageNo : 0,
      size : 20,
      startIndex : 0,
      totalCount : 0
    },
    deleteFileList: [],
    usedAmountProductList: [],
    usedAmountPaging: {},
    productRankList: [],
    productRankPaging: {}
  },

  getters: {
    codeProductList: state => state.codeProductList,
    productSearchParam: state => state.productSearchParam,
    productCustomerSearchParam: state => state.productCustomerSearchParam,
    productRankSearchParam: state => state.productRankSearchParam,
    productList: (state) => state.productList,
    pagingDTO: (state) => state.pagingDTO,
    selectProduct: (state) => state.selectProduct,
    selectProductInfo: (state) => state.selectProductInfo,
    codeProductUpdate: (state) => state.codeProductUpdate,
    codeProductFileUpdate: (state) => state.codeProductFileUpdate,
    codeSelectProductInfo: (state) => state.codeSelectProductInfo,
    fileInfo: (state) => state.fileInfo,
    deleteFileList: (state) => state.deleteFileList,
    usedAmountProductList: (state) => state.usedAmountProductList,
    usedAmountPaging: (state) => state.usedAmountPaging,
    productRankList: (state) => state.productRankList,
    productRankPaging: (state) => state.productRankPaging
  },

  mutations: {
    [types.GET_PRODUCT_CUSTOMER_SEARCH_PARAM]: (state, payload) => {
      state.productCustomerSearchParam = payload.productCustomerSearchParam
    },
    [types.GET_PRODUCT_RANK_SEARCH_PARAM]: (state, payload) => {
      state.productRankSearchParam = payload.productRankSearchParam
    },
    [types.GET_PRODUCT_SEARCH_PARAM]: (state, payload) => {
      state.productSearchParam = payload.productSearchParam
    },
    [types.CREATE_PRODUCT_STATUS]: (state, payload) => {
      state.codeProductUpdate = payload.codeProductUpdate
    },
    [types.CREATE_PRODUCT_FILE_STATUS]: (state, payload) => {
      state.codeProductFileUpdate = payload.codeProductFileUpdate
    },
    [types.GET_PRODUCT_LIST]: (state, payload) => {
      state.codeProductList = payload.codeProductList
      state.productList = payload.productList
    },
    [types.SET_SELECT_PRODUCT]: (state, payload) => {
      state.selectProduct = payload.selectProduct
      state.codeSelectProductInfo = payload.codeSelectProductInfoa
    },
    [types.GET_SELECT_PRODUCT_INFO]: (state, payload) => {
      state.selectProductInfo = payload.selectProductInfo
    },
    [types.CLEAR_SELECT_PRODUCT_INFO]: (state, payload) => {
      state.selectProductInfo = {}
    },
    [types.UPDATE_PRODUCT_INFO]: (state, payload) => {
      state.selectProductInfo = {
        ...state.selectProductInfo,
        ...payload.updateProductInfo
      }
    },
    [types.CHUNK_FILE_UPLOAD]: (state, payload) => {
      const {fileName, chunkedCount, index, id} = payload
      state.fileInfo = {
        ...state.fileInfo,
        [fileName]: { id, type: 'basic', value: Math.floor(index / chunkedCount * 100) }
      }
    },
    [types.DELETE_FILE]: () => {},
    [types.ADD_DELETE_FILE]: (state, payload) => {
      state.deleteFileList = [...state.deleteFileList, payload]
    },
    [types.CLEAR_DELETE_FILE_LIST]: (state) => {
      state.deleteFileList = []
    },
    [types.CREATE_SELECT_PRODUCT_INFO_STATUS]: (state, payload) => {
      state.codeSelectProductInfo = payload.codeSelectProductInfo
      state.productException = payload.productException || {}
    },
    [types.GET_USED_AMOUNT_PRODUCT_LIST]: (state, payload) => {
      state.usedAmountProductList = payload.usedAmountProductList
    },
    [types.GET_USED_AMOUNT_PRODUCT_PAGING]: (state, payload) => {
      state.usedAmountPaging = payload.usedAmountPaging
    },
    [types.GET_PRODUCT_RANK_LIST]: (state, payload) => {
      state.productRankList = payload.productRankList
    },
    [types.GET_PRODUCT_RANK_PAGING]: (state, payload) => {
      state.productRankPaging = payload.productRankPaging
    },
  },

  actions: {
    setProductCustomerSearchParam ( {commit }, payload) {
      commit(types.GET_PRODUCT_CUSTOMER_SEARCH_PARAM, { productCustomerSearchParam: payload })
    },
    setProductRankSearchParam ( {commit }, payload) {
      commit(types.GET_PRODUCT_RANK_SEARCH_PARAM, { productRankSearchParam: payload })
    },
    setProductSearchParam ( {commit }, payload) {
      commit(types.GET_PRODUCT_SEARCH_PARAM, { productSearchParam: payload })
    },
    async getProductList ({commit}, payload) {
      const { searchText, category } = payload
      commit (types.GET_PRODUCT_LIST, { productList: [], codeProductList: CodeList.READY })
      try {
        const response = await ProductServices.getProducts({
          searchText, category
        })
        commit (types.GET_PRODUCT_LIST, {
          productList: response.data.resultData.map((item, index) => {
            return {
              no: index + 1,
              ...item
            }
          }),
          codeProductList: CodeList.SUCCESS
        })
      } catch (e) {
        commit (types.GET_PRODUCT_LIST, {
          productList: [],
          codeProductList: CodeList.EXCEPTION
        })
      }
      return null
    },
    async setSelectProduct ({commit}, payload) {
      const selectProduct = payload.selectProduct
      commit(types.SET_SELECT_PRODUCT, {selectProduct})
      return selectProduct
    },
    async getSelectProductInfo ({commit, rootGetters}, stratCode) {

      commit(types.CREATE_SELECT_PRODUCT_INFO_STATUS, {codeSelectProductInfo: CodeCreate.READY})

      try {
        const response = await ProductServices.getProductsWithStartCode(stratCode)

        const selectProductInfo = response.data.resultData
        const userInfo = rootGetters['user/userInfo']
        if (userInfo.auth !== AUTH_GROUP.BespinAdmin && selectProductInfo.stat === 'N') {
          commit(types.CREATE_SELECT_PRODUCT_INFO_STATUS, {codeSelectProductInfo: CodeCreate.EXCEPTION})
          return null
        }
        commit(types.GET_SELECT_PRODUCT_INFO, {selectProductInfo: response.data.resultData})
        commit(types.CREATE_SELECT_PRODUCT_INFO_STATUS, {codeSelectProductInfo: CodeCreate.SUCCESS})
      } catch (e) {
        commit(types.CREATE_SELECT_PRODUCT_INFO_STATUS, {codeSelectProductInfo: CodeCreate.EXCEPTION, productException: e})
      }
      return null
    },
    async clearSelectProductInfo ({commit}) {
      commit(types.CLEAR_SELECT_PRODUCT_INFO)
    },
    async updateProductInfo ({state, commit, dispatch, rootGetters}, {productInfo}) {
      const loginUserInfo = rootGetters['user/userInfo']
      commit(types.CREATE_PRODUCT_STATUS, {codeProductUpdate: CodeCreate.READY})
      for (let deleteFile of state.deleteFileList) {
        await dispatch('deleteFile', deleteFile)
      }
      Object.entries(productInfo.file).forEach(([key, fileList]) => {
        if (fileList.length > 0) {
          const file = fileList[0]
          productInfo[`${key}FileId`] = file.id
        } else {
          productInfo[`${key}FileId`] = null
        }
      })
      const response = await ProductServices.putProducts({...productInfo, companyCode: loginUserInfo.companyCode})
      dispatch('getSelectProductInfo', response.data.resultData.stratCode)
      commit(types.CREATE_PRODUCT_STATUS, {codeProductUpdate: CodeCreate.SUCCESS})
      return response
    },
    async updateProductInfoFile ({state, commit, dispatch, rootGetters}, {productInfo}) {
      const loginUserInfo = rootGetters['user/userInfo']
      commit(types.CREATE_PRODUCT_FILE_STATUS, {codeProductFileUpdate: CodeCreate.READY})

      Object.entries(productInfo.file).forEach(([key, fileList]) => {
        if (fileList.length > 0) {
          const file = fileList[0]
          productInfo[`${key}FileId`] = file.id
        } else {
          productInfo[`${key}FileId`] = null
        }
      })

      const response = await ProductServices.putProducts({...state.selectProductInfo, ...productInfo, companyCode: loginUserInfo.companyCode})
      dispatch('getSelectProductInfo', response.data.resultData.stratCode)
      commit(types.CREATE_PRODUCT_FILE_STATUS, {codeProductFileUpdate: CodeCreate.SUCCESS})
      return response
    },
    async upload ({commit}, payload) {
      commit(types.CHUNK_FILE_UPLOAD, payload)
      return payload
    },
    async deleteFile ({commit}, payload) {
      const {id, stratCode, type} = payload
      await ProductServices.putProductsFiles({fileId: id, stratCode, type})
      commit(types.DELETE_FILE, {id})
      return id
    },
    async addDeleteFile ({commit}, payload) {
      commit(types.ADD_DELETE_FILE, payload)
    },
    async clearDeleteFile ({commit}) {
      commit(types.CLEAR_DELETE_FILE_LIST)
    },
    async getUsedAmountProductList ({commit}, payload) {
      commit (types.GET_USED_AMOUNT_PRODUCT_LIST, { usedAmountProductList: [], })
      const response = await ProductServices.getUsedAmountProductList(payload)
      commit(types.GET_USED_AMOUNT_PRODUCT_LIST, { usedAmountProductList: response.data.resultData.list })
      commit(types.GET_USED_AMOUNT_PRODUCT_PAGING, { usedAmountPaging: response.data.resultData.pagingDTO })

    },
    async getCSVDownLoad({commit}, payload){
     await FileServices.getCSVFile(payload)
   },
    async getProductRankList ({commit}, payload) {
      commit (types.GET_PRODUCT_RANK_LIST, { productRankList: [], })
      const response = await ProductServices.getProductRankList(payload)
      commit(types.GET_PRODUCT_RANK_LIST, { productRankList: response.data.resultData.list })
      commit(types.GET_PRODUCT_RANK_PAGING, { productRankPaging: response.data.resultData.pagingDTO })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js